var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"s-image",class:{'pointer': !!_vm.link},style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.src,"alt":""},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }